const locale = {
	USER: 'User',
	USER_LIST: 'Access',
	DASHBOARD_ROLE: 'Role'
};

export default locale;
